enum ButtonColor {
  primary = 'primary',
  secondary = 'secondary',
  transparent = 'transparent',
  light = 'light',
  grey = 'grey',
  border = 'border',
  default = 'default',
  warning = 'warning'
}

enum ButtonSize {
  small = 'small',
  medium = 'medium',
  large = 'large',
  extraLarge = 'extraLarge',
  fullWidth = 'fullWidth',
  smallIcon = 'smallIcon',
  default = 'default',
}

enum Icons {
  shore = 'shore',
  question = 'question',
  important = 'important',
  subtract = 'subtract',
  area = 'area',
  arrowUp = 'arrowUp',
  arrowDown = 'arrowDown',
  apartment = 'apartment',
  bed = 'bed',
  calendar = 'calendar',
  chartPie36 = 'chartPie36',
  check = 'check',
  chevronUp = 'chevronUp',
  chevronDown = 'chevronDown',
  chevronLeft = 'chevronLeft',
  chevronRight = 'chevronRight',
  crane = 'crane',
  columns = 'columns',
  coins = 'coins',
  cross = 'cross',
  dollar = 'dollar',
  dotMenu = 'dotMenu',
  edit = 'edit',
  eye = 'eye',
  eyeClosed = 'eyeClosed',
  excel = 'excel',
  filter = 'filter',
  floors = 'floors',
  handShake = 'handShake',
  hourglass = 'hourglass',
  house = 'house',
  info = 'info',
  list = 'list',
  key = 'key',
  mapDraw = 'mapDraw',
  mapMark = 'mapMark',
  menu8 = 'menu8',
  pin = 'pin',
  pin3 = 'pin3',
  plus = 'plus',
  ranking = 'ranking',
  remove = 'remove',
  report = 'report',
  refresh = 'refresh',
  save = 'save',
  search = 'search',
  speaker = 'speaker',
  trashcan = 'trashcan',
  weightOne = 'weightOne',
  weightTwo = 'weightTwo',
  weightThree = 'weightThree',
  loading = 'loading',
  aboutFilter = 'aboutFilter'
}

enum IconSize {
  extraSmall = '8',
  small = '12',
  medium = '15',
  large = '20',
  xlarge = '40',
}

enum IconColor {
  default = 'currentColor',
  white = 'white',
  gray = 'gray',
  success = '#367D42',
  warning = '#D33636'
}

enum TagColor {
  primary = 'primary',
  blue = 'blue',
  purple = 'purple',
  orange = 'orange',
  cyan = 'cyan',
  green = 'green',
  emerald = 'emerald',
  indigo = 'indigo',
  violet = 'violet',
  pink = 'pink',
  amber = 'amber',
  red = 'red',
}

enum LineMargin {
  small = '0.5rem',
  medium = '1rem',
  large = '2rem',
}

enum TooltipPosition {
  top = 'top',
  bottom = 'bottom',
  left = 'left',
  right = 'right',
}

enum TableEnum {
  ads = 'ads',
  sold = 'sold',
}

enum ColumnEnum {
  adPrice = 'ad_price',
  adress = 'adress',
  street = 'street',
  rooms = 'rooms',
  livingArea = 'livingArea',
  floorFloors = 'floorFloors',
  constructionYear = 'constructionYear',
  homeType = 'homeType',
  soldPrice = 'soldPrice',
  price = 'price',
  monthlyFee = 'monthly_fee',
  recountedPrice = 'recounted_price',
  contractDate = 'contract_date',
  ownSale = 'ownSale',
  firm = 'firm',
  ancillaryArea = 'ancillary_area',
  plotArea = 'plot_area',
  active = 'active',
  pdf = 'pdf',
  floor = 'floor',
  floors = 'floors',
  priceTaxationRatio = 'price_taxation_ratio',
  soldPriceSqm = 'sold_price_sqm',
  recountedPriceSqm = 'recounted_price_sqm',
  taxasionValue = 'taxation_value',
  taxationYear = 'taxation_year',
  monthlyFeeSqm = 'monthly_fee_sqm',
  source = 'source',
  adAdvertisingDays = 'ad_advertising_days',
  advertisingDays = 'advertising_days',
  adRegisteredDate = 'ad_registered_date',
  registeredDate = 'registered_date',
  adDeleteDate = 'ad_delete_date',
  propertyUnitDesignation = 'property_unit_designation',
  adPriceSqm = 'ad_price_sqm',
  priceSqm = 'price_sqm',
  prospectUrl = 'prospect_url',
  ownershipType = 'ownership_type',
  ownerName = 'owner_name',
  ownerId = 'owner_id',
  allabrfUrl = 'allabrf_url',
  allabolagUrl = 'allabolag_url',
  valuationYear = 'valuation_year',
  shoreDistanceType = 'shore_distance_type',
  waterSewerageType = 'water_sewerage_type',
  alterationYear = 'alteration_year',
  standardPoints = 'standard_points',
  leaseholdFee = 'leasehold_fee',
  leaseholdPeriod = 'leasehold_period',
  subdivisionType = 'subdivision_type',
  housingAssociationReportYear = 'housing_association_report_year',
  balcony = 'balcony',
  elevator = 'elevator',
}

enum ChipEnum {
  select = 'select',
  slider = 'slider',
  sliderRange = 'sliderRange',
}

enum Weights {
  none = 0,
  low = 50,
  medium = 500,
  high = 1000,
}

enum AdsWeightParams {
  distance_weight = 'distance_weight',
  registered_date_weight = 'registered_date_weight',
  rooms_weight = 'rooms_weight',
  living_area_weight = 'living_area_weight',
  monthly_fee_weight = 'monthly_fee_weight',
  construction_year_weight = 'construction_year_weight',
  floor_weight = 'floor_weight',
  floors_weight = 'floors_weight',
  population_center_weight = 'population_center_weight',
}

enum AdsRefParams {
  construction_year_reference = 'construction_year_reference',
  floor_reference = 'floor_reference',
  floors_reference = 'floors_reference',
  living_area_reference = 'living_area_reference',
  monthly_fee_reference = 'monthly_fee_reference',
  registered_date_reference = 'registered_date_reference',
  rooms_reference = 'rooms_reference',
  use_fpr_data = 'use_fpr_data',
  wgs84lat = 'wgs84lat',
  wgs84lon = 'wgs84lon',
}

enum AdsFilterParams {
  ad_advertising_days_min = 'ad_advertising_days_min',
  ad_advertising_days_max = 'ad_advertising_days_max',
  homeType = 'home_type',
  is_close_to_population_centre = 'is_close_to_population_centre',
  construction_year_min = 'construction_year_min',
  construction_year_max = 'construction_year_max',
  error_code = 'error_code',
  ownership_type = 'ownership_type',
  living_area_min = 'living_area_min',
  living_area_max = 'living_area_max',
  registered_date_min = 'registered_date_min',
  registered_date_max = 'registered_date_max',
  owner_id = 'owner_id',
  rooms_min = 'rooms_min',
  rooms_max = 'rooms_max',
  price_min = 'price_min',
  price_max = 'price_max',
  excluded_ad_ids = 'excluded_ad_ids',
  is_new_construction = 'is_new_construction',
  limit = 'limit',
}

enum MarketFilterParams {
  homeType = 'home_type',
  construction_year_min = 'construction_year_min',
  construction_year_max = 'construction_year_max',
  ownership_type = 'ownership_type',
  registered_date_min = 'registered_date_min',
  registered_date_max = 'registered_date_max',
  living_area_min = 'living_area_min',
  living_area_max = 'living_area_max',
  monthly_fee_max = 'monthly_fee_max',
  monthly_fee_min = 'monthly_fee_min',
  // orgNr = 'orgNr',
  rooms_min = 'rooms_min',
  rooms_max = 'rooms_max',
  price_min = 'price_min',
  price_max = 'price_max',
}

enum AdsFilterListParams {
  is_close_to_population_centre = 'is_close_to_population_centre',
  is_new_construction = 'is_new_construction',
}

enum SoldRefParams {
  construction_year_reference = 'construction_year_reference',
  floor_reference = 'floor_reference',
  floors_reference = 'floors_reference',
  living_area_reference = 'living_area_reference',
  monthly_fee_reference = 'monthly_fee_reference',
  rooms_reference = 'rooms_reference',
  use_fpr_data = 'use_fpr_data',
  wgs84lat = 'wgs84lat',
  wgs84lon = 'wgs84lon',
}

enum SoldWeightParams {
  construction_year_weight = 'construction_year_weight',
  contract_date_weight = 'contract_date_weight',
  distance_weight = 'distance_weight',
  floor_weight = 'floor_weight',
  floors_weight = 'floors_weight',
  living_area_weight = 'living_area_weight',
  monthly_fee_weight = 'monthly_fee_weight',
  rooms_weight = 'rooms_weight',
  population_center_weight = 'population_center_weight',
}

enum SoldFilterParams {
  // advertising_days = 'advertising_days',
  homeType = 'home_type',
  is_close_to_population_centre = 'is_close_to_population_centre',
  construction_year_min = 'construction_year_min',
  construction_year_max = 'construction_year_max',
  contract_date_min = 'contract_date_min',
  contract_date_max = 'contract_date_max',
  distance_center = 'distance_center',
  error_code = 'error_code',
  shore_distance_min = 'shore_distance_min',
  shore_distance_max = 'shore_distance_max',
  ownership_type = 'ownership_type',
  owner_id = 'owner_id',
  living_area_min = 'living_area_min',
  living_area_max = 'living_area_max',
  monthly_fee_max = 'monthly_fee_max',
  monthly_fee_min = 'monthly_fee_min',
  is_new_construction = 'is_new_construction',
  // orgNr = 'orgNr',
  rooms_min = 'rooms_min',
  rooms_max = 'rooms_max',
  price_min = 'price_min',
  price_max = 'price_max',
  floor_min = 'floor_min',
  floor_max = 'floor_max'
}

enum SoldFilterListParams {
  org_number = 'org_number',
  show_new_productions = 'show_new_productions',
  show_inadequate_data = 'show_inadequate_data',
  distance_to_center = 'distance_to_center',
}

enum TableSize {
  small = 'small',
  medium = 'medium',
  default = 'default',
}

enum SearchParams {
  all = 'all',
  ref = 'ref',
  weight = 'weight',
  filter = 'filter',
  weightRef = 'weightRef',
  advancedFilter = 'advancedFilter'
}

enum TooltipColor {
  primary = 'primary',
  secondary = 'secondary',
}

enum HomeTypeEnum {
  apartment = 'apartment',
  house = 'house',
  farm = 'farm',
  plot = 'plot',
  terracedHouse = 'terraced_house',
  townhouse = 'townhouse',
}

enum OwnershipType {
  coOperativeApartment = 'co_operative_apartment',
  propertyRights = 'property_rights',
  siteLeasehold = 'site_leasehold',
  lease = 'lease',
  other = 'unknown',
}

enum GraphType {
  fromMap = 'Referenspris från karta',
  fromSqm = 'Referenspris från sålda i kronor per kvm',
  index = 'Index',
}

enum TabsType {
  sold = 'sold',
  ads = 'ads',
  market = 'market',
  priceDevelopment = 'priceDevelopment',
}

enum MapTypeIdsType {
  terrain = 'terrain',
  satellite = 'satellite',
  hybrid = 'hybrid',
  roadmap = 'roadmap',
}

enum ColumnChoiceType {
  sold = 'columnSaleInfo',
  ads = 'columnAdInfo',
  realEstate = 'columnRealEstateInfo',
  coOperative = 'columnCoOperative',
  littleHouse = 'columnLittleHouse',
  ownChoice = 'ownChoice',
}

export {
  AdsRefParams,
  AdsFilterParams,
  AdsFilterListParams,
  AdsWeightParams,
  ButtonColor,
  ButtonSize,
  HomeTypeEnum,
  ColumnEnum,
  ColumnChoiceType,
  ChipEnum,
  GraphType,
  Icons,
  IconColor,
  IconSize,
  LineMargin,
  MarketFilterParams,
  MapTypeIdsType,
  OwnershipType,
  SearchParams,
  SoldRefParams,
  SoldWeightParams,
  SoldFilterListParams,
  SoldFilterParams,
  TableEnum,
  TooltipPosition,
  TabsType,
  TableSize,
  TagColor,
  TooltipColor,
  Weights
};
